module.exports = __webpack_public_path__ + "static/media/Prizm.5f196f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/Home/Prizm.png
// module id = 412
// module chunks = 0